import { useEffect, useState } from "react";

const Toast = ({ message, type = "success", onClose }) => {
  const [renderMessage, setRenderMessage] = useState("");

  useEffect(() => {
    // 🔥 force screen reader detection
    setRenderMessage("");

    const timer = setTimeout(() => {
      setRenderMessage(message);
    }, 50);

    return () => clearTimeout(timer);
  }, [message]);

  useEffect(() => {
    const timer = setTimeout(onClose, 2500);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      role={type === "error" ? "alert" : "status"}
      aria-live={type === "error" ? "assertive" : "polite"}
      aria-atomic="true"
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        backgroundColor: type === "error" ? "#f44336" : "#4caf50",
        color: "#fff",
        padding: "14px 18px",
        borderRadius: "8px",
        zIndex: 9999,
        minWidth: "280px",
      }}
    >
      {renderMessage}
    </div>
  );
};

export default Toast;